import { Colors } from '../../styles/Colors';

export const cardTypes = {
  BOOK: { type: 'BOOK', color: Colors.brandPrimary },
  BOOKED: { type: 'BOOKED', color: Colors.brandSuccess },
  WAITLIST: { type: 'WAITLIST', color: Colors.brandWarning },
  WAITLISTED: { type: 'WAITLISTED', color: Colors.brandWarning },
};
